<template>
  <div class="wrap">
    <el-button :type="buttonType" @click="onExport">
      <slot>导出</slot>
    </el-button>
    <el-dialog title="导出" custom-class="dialog" :visible.sync="isShow" width="500px" :destroy-on-close="true"
      :close-on-click-modal="false" @close="onClose" append-to-body>
      <div class="content">
        <p>
          正在生成导出文件，请前往<span>【我的导出】</span>中查看和下载文件。
        </p>
        <div class="btn mt20">
          <el-button type="primary" @click="$router.push('/patrol/patrolExport')">立即前往</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "",
    },
    buttonType: {
      type: String,
      default: "primary",
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isShow: false,
    };
  },
  methods: {
    getExportUrl() {
      const exportMap = new Map();
      exportMap.set("0", this.$apis.patrol.exportIssue); // 导出巡查问题清单
      exportMap.set("1", this.$apis.patrol.planexporttoexcel); // 导出巡查管理表单
      exportMap.set("2", this.$apis.patrol.taskexporttoexcel); // 导出巡查管理-执行记录-任务记录表单
      exportMap.set("3", this.$apis.patrol.facilityExcel); // 资产导出

      exportMap.set("4", this.$apis.workOrder.exportLcIssueWord); // 导出问题 详情工单 word
      exportMap.set("5", this.$apis.workOrder.exportLcIssueExcel); // 导出问题工单 excel
      exportMap.set("6", this.$apis.workOrder.exportLcWorkOrderWord); // 导出养护 详情工单 word
      exportMap.set("7", this.$apis.workOrder.exportLcWorkOrderExcel); // 导出养护工单 excel

      exportMap.set("8", this.$apis.patrol.completedPointDownload); // 导出巡查点位图片

      exportMap.set("9", this.$apis.tourist.exportMydQuestionnaireStatistic); // 导出调查问卷汇总表
      exportMap.set("10", this.$apis.tourist.exportMydQuestionnaireResult); // 导出满意率调查问卷表

      exportMap.set("11", this.$apis.material.exportExcel3); // 导出出入库明细表
      exportMap.set("12", this.$apis.material.exportExcel4); // 导出物料库存表
      exportMap.set("13", this.$apis.material.exportProjectDailyWord); // 导出物料库存表

      exportMap.set("14", this.$apis.patrol.exportWord); // 导出任务记录
      return exportMap.get(this.type);
    },
    onExport() {
      if (this.type === '13') {
        if (!this.params.projectId) {
          this.$message.error("请选择所属项目！");
          return
        }
      }
      this.$axios.get(this.getExportUrl(), this.params).then((res) => {
        if (res === 0) {
          this.$message.error("导出失败:当前条件下没有数据!");
        } else {
          this.isShow = true;
        }
      });
    },
    onClose() {
      this.isShow = false;
    },
  },
};
</script>
<style scoped lang="scss">
.wrap {
  display: inline-flex;
  margin-left: 10px;
  z-index: 9999;
}

.content {
  p {
    text-align: center;

    span {
      color: #1eb6ae;
    }
  }

  .btn {
    display: flex;
    justify-content: center;
  }
}

.dialog {
  z-index: 9999;
}
</style>
